import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { CampaignProduct } from "../../models/campaign-product.model";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class OrderEventsService {
  private API_ORDEREVENTS_URL = environment.API_URL + "api/orderevent";
  private API_ORDEREVENTS_TRACKING_URL = environment.API_URL + "api/OrderEvent/OrderEventTracking";
  private API_ORDEREVENTS_TYPES_URL = environment.API_URL + "api/OrderEventType";
  private API_ORDEREVENTS_RESULTS_URL = environment.API_URL + "api/OrderEventResult";
  private API_CAMPAIGN_PRODUCTS_URL = environment.API_URL + "api/campaign-products";
  private API_CURRENT_CAMPAIGN_PRODUCTS_URL = environment.API_URL + "api/campaign-products/currentcampaign";
  private API_CAMPAIGN_PRODUCTS_COMPUTABLE_URL = environment.API_URL + "api/campaign-products/computable";
  private API_CAMPAIGN_PRODUCTS_CURRENT_COMPUTABLE_URL =
    environment.API_URL + "api/campaign-products/currentcomputable";
  private API_CONTROL_LIST_URL = environment.API_URL + "api/OrderEvent/ControlList";
  private API_RESELLER_IMPORT = environment.API_URL + "api/OrderEvent/uploadordereventsresellers/";
  private API_ZONE_IMPORT = environment.API_URL + "api/OrderEvent/uploadordereventszone/";
  private API_EVENTS_EXPORT = environment.API_URL + "api/OrderEvent/downloadorderevents";
  private API_EVENTS_ZONE_EXPORT = environment.API_URL + "api/OrderEvent/downloadordereventszone";
  private API_EVENTS_LIST_EXPORT = environment.API_URL + "api/OrderEvent/downloadordereventslist";
  private API_EVENTS_RECEIVED_IMPORT = environment.API_URL + "api/OrderEvent/uploadordereventsreceivedproducts/";

  constructor(private http: HttpClient, private fileService: FileService, private httpUtils: HttpUtilsService) {}

  findOrderEvents(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = this.API_ORDEREVENTS_URL + "/find";
    return this.http.post<QueryResultsModel>(url, queryParams, { headers: httpHeaders });
  }

  getOrderEvent(id): Observable<any> {
    return this.http.get(this.API_ORDEREVENTS_URL + "/" + id);
  }

    getOrderEventControl(id): Observable<any> {
        return this.http.get(this.API_ORDEREVENTS_URL + "/control/" + id);
    }

  getOrderEventTypes(): Observable<any> {
    return this.http.get(this.API_ORDEREVENTS_TYPES_URL);
  }

  getOrderEventResults(): Observable<any> {
    return this.http.get(this.API_ORDEREVENTS_RESULTS_URL);
  }

  getProductsByCampaign(idCmp): Observable<CampaignProduct[]> {
    return this.http.get<CampaignProduct[]>(this.API_CAMPAIGN_PRODUCTS_URL + "?campaignId=" + idCmp);
  }

  getProductsCurrentCampaign(): Observable<CampaignProduct[]> {
    return this.http.get<CampaignProduct[]>(this.API_CURRENT_CAMPAIGN_PRODUCTS_URL);
  }

  //
  // importExcel(element, idCmp) {
  // 	return this.fileService.fileUpload(element, this.API_FILE_CAMPAIGN_PRODUCTS_URL + idCmp);
  // }
  //
  // // READ
  // getAllProducts(): Observable<Product[]> {
  // 	return this.http.get<Product[]>(this.API_PRODUCTS_URL);
  // }
  //
  // CREATE =>  POST: add a new product to the server
  createOrderEvent(orderEvent): Observable<any> {
    return this.http.post<any>(this.API_ORDEREVENTS_URL, orderEvent);
  }

  createOrderEventTracking(orderEventTracking, id): Observable<any> {
    return this.http.post<any>(this.API_ORDEREVENTS_TRACKING_URL + "/" + id, orderEventTracking);
  }

  //
  // getProductCategories(): Observable<ProductCategory[]> {
  // 	return this.http.get<ProductCategory[]>(this.API_PRODUCTS_CATEGORIES_URL);
  // }
  //
  updateOrderEvent(orderEvent, id) {
    orderEvent.id = id;
    return this.http.put<any>(`${this.API_ORDEREVENTS_URL}/${id}`, orderEvent);
  }
  //
  deleteOrderEvent(id: any) {
    return this.http.delete<any>(`${this.API_ORDEREVENTS_URL}/${id}`);
  }
  //
  // uploadImage(productId: number, fileToUpload: File, imageType: string): Observable<any> {
  // 	const url = `${this.API_PRODUCTS_URL}/imageupload/${productId}`;
  // 	const formData: FormData = new FormData();
  // 	formData.append('file', fileToUpload, fileToUpload.name);
  // 	return this.http.post(url, formData);
  // }
  getProductsCampaignComputable(campaignId) {
    return this.http.get<CampaignProduct[]>(`${this.API_CAMPAIGN_PRODUCTS_COMPUTABLE_URL}/${campaignId}`);
  }

  getProductsCampaignCurrentComputable(userId) {
    return this.http.get<CampaignProduct[]>(`${this.API_CAMPAIGN_PRODUCTS_CURRENT_COMPUTABLE_URL}/${userId}`);
  }

  getControlList() {
    return this.http.get(`${this.API_CONTROL_LIST_URL}`);
  }

  exportExcel(data, url, method) {
    if (method === "get") {
      return this.http.get(url, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    } else {
      return this.http.post(url, data, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    }
  }

  importResellers(element, data) {
    return this.fileService.fileUpload(element, this.API_RESELLER_IMPORT);
  }

  importZone(element, data) {
    return this.fileService.fileUpload(element, this.API_ZONE_IMPORT + data.campaignId);
  }

  importReceived(element, data) {
    return this.fileService.fileUpload(element, this.API_EVENTS_RECEIVED_IMPORT + data.campaignId);
  }

  downloadEvents(data) {
    let url = `${this.API_EVENTS_EXPORT}?campaignId=${data.campaignId}&Zone=${data.zone}`;
    return this.exportExcel(data, url, "post");
  }

  downloadEventsZone(data) {
    let url = `${this.API_EVENTS_ZONE_EXPORT}?campaignId=${data.campaignId}&Zone=${data.zone}`;
    return this.exportExcel(data, url, "post");
  }

  downloadEventsList() {
    let data = "";
    let url = `${this.API_EVENTS_LIST_EXPORT}`;
    return this.exportExcel(data, url, "post");
  }

  getOrderEventsForOrder(orderId) {
      return this.http.get(this.API_ORDEREVENTS_URL + '/order/' + orderId)
  }
}
